/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { removeIncorrectTracksCommandSchema } from "../removeIncorrectTracksCommandSchema.ts";
import { z } from "zod";

/**
 * @description Успешно
 */
export const postApiTestRemoveIncorrectTracks200Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const postApiTestRemoveIncorrectTracks400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiTestRemoveIncorrectTracks401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiTestRemoveIncorrectTracks403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiTestRemoveIncorrectTracks500Schema = z.lazy(() => badResponseModelSchema)

export const postApiTestRemoveIncorrectTracksMutationRequestSchema = z.lazy(() => removeIncorrectTracksCommandSchema)

export const postApiTestRemoveIncorrectTracksMutationResponseSchema = z.lazy(() => postApiTestRemoveIncorrectTracks200Schema)